'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var dyzioGreen = exports.dyzioGreen = {
  color: '#20c49e'
};

var smallFont = exports.smallFont = {
  fontSize: '60%',
  color: 'grey'
};

var ellipsisWrapper = exports.ellipsisWrapper = {
  width: '100%'
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/reports/basic-report-row/components/style.js
 ** module id = 2616
 ** module chunks = 0
 **/